import { render, staticRenderFns } from "./BettingBox.vue?vue&type=template&id=6a937bbf&"
import script from "./BettingBox.vue?vue&type=script&lang=js&"
export * from "./BettingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports